// extracted by mini-css-extract-plugin
export default {"lastUpdate":"Schedule_lastUpdate__779+d"};